"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartiesListPure = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var PartiesListContainer_1 = require("./PartiesListContainer");
var translate_1 = require("utils/translate");
require("./style.scss");
var mapStateToProps = function () {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var PartiesListPure = function (props) { return (React.createElement("div", { className: 'users-list-view' },
    React.createElement(PartiesListContainer_1.PartiesListContainer, { currentProject: props.currentProject }))); };
exports.PartiesListPure = PartiesListPure;
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, react_redux_1.connect)(exports.mapStateToProps), recompose_1.pure);
exports.default = enhance(exports.PartiesListPure);
